"use client";
import React from "react";


function DashboardCompany() {
  return (
    <>
      <main className="overflow-hidden relative w-full bg-slate-100 flex">
        <section className="flex-1 p-10 ml-[300px] max-md:ml-[250px] max-sm:ml-[50px] max-sm:mt-16">
          <h1 className="text-2xl font-bold text-indigo-700">Welcome to Dashboard!</h1>
          <p className="mt-4 text-sm text-slate-500">
            Here you can manage your profile, view job listings table, edit job vacancy, add new job, and much more.
          </p>
        </section>
        
      </main>
    </>
  );
}

export default DashboardCompany;
